export default __webpack_public_path__ + "static/media/preview-icon.a392b4ab.svg";